import { IAdminIssueReportListItem } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

//어드민 - 접수된 오류 및 처리 완료 페이지: 테이블에 보여줄 리스트 데이터
async function getAdminIssueReportList(
  page: number,
  status?: string
): Promise<AxiosResponse<FetchResult<IAdminIssueReportListItem[]>>> {
  const response = await instance.get(`/images/issue-reports?isResolved=${status === 'resolved'}&page=${page}&take=20`);
  return response;
}

const useFetchAdminIssueReportList = (page: number, status?: string) => {
  const { data: originalData } = useQuery({
    queryKey: ['get', `/images/issue-reports?isResolved=${status === 'resolved'}&page=${page}&take=20`],
    queryFn: () => getAdminIssueReportList(page, status),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(page && status)
  });

  const response = originalData?.data;

  return { response };
};

export default useFetchAdminIssueReportList;
